export default "__VITE_ASSET__CPeQuDdR__"